import { Link } from "react-router-dom";
import { useBrand, LogoMark } from "../../context/BrandContext";

export const Logo = ({ compact = false }) => {
  const b = useBrand();
  const img = !!b.logo_url;
  return (
    <Link to="/" className="flex items-center gap-2.5 sm:gap-3 group" data-testid="header-logo-link">
      <LogoMark size={img ? "w-10 h-10 lg:w-[52px] lg:h-[52px]" : "w-10 h-10"} testid={img ? "brand-logo-img" : "brand-logo-fallback"} />
      <div className="leading-none">
        <div className="font-display font-extrabold uppercase tracking-wide text-slate-900 text-[15px] sm:text-lg group-hover:text-brand-600 transition-colors flex flex-col sm:flex-row sm:gap-1.5 leading-[0.95]">
          <span>Echevarria</span> <span className="text-brand-600">Trucking</span>
        </div>
        {!compact && <div className="hidden sm:block font-mono text-[10px] tracking-[0.2em] text-slate-500 mt-1">USDOT {b.usdot}</div>}
      </div>
    </Link>
  );
};
